import { useEffect, useRef, useState } from 'react';

import { GUIDE_BASE } from './walletUtils';

// Se descarga una sola vez por sesión
let guideCache: string | null = null;

const loadGuide = async () => {
    if (guideCache) return guideCache;
    const resp = await fetch(`${GUIDE_BASE}/guia-mis-disenos.html`);
    if (!resp.ok) throw new Error(String(resp.status));
    const html = await resp.text();
    // El fragmento referencia las imágenes como "img/...": se apuntan a la carpeta publicada
    guideCache = html.replace(/(src|href)="img\//g, `$1="${GUIDE_BASE}/img/`);
    return guideCache;
};

interface WalletGuidePanelProps {
    onClose: () => void;
    section?: string;   // id de la sección a mostrar (ej. "sp-paso1")
}

// Guía "Crea el diseño de tu tarjeta de lealtad" en un panel lateral (a pantalla completa en celular).
// Sus estilos vienen encapsulados bajo .sp-guia y no afectan al resto del portal.
export const WalletGuidePanel = ({ onClose, section }: WalletGuidePanelProps) => {
    const [html, setHtml] = useState<string | null>(guideCache);
    const [error, setError] = useState(false);
    const bodyRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (html) return;
        loadGuide().then(setHtml).catch(() => setError(true));
    }, []);

    useEffect(() => {
        if (!html || !section) return;
        bodyRef.current?.querySelector(`#${section}`)?.scrollIntoView({ block: 'start' });
    }, [html, section]);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1060 }} onClick={onClose} />
            <div className="offcanvas offcanvas-end show" tabIndex={-1} role="dialog" aria-label="¿Cómo crear mi diseño?"
                style={{ visibility: 'visible', width: 'min(900px, 100vw)', zIndex: 1065 }}>
                <div className="offcanvas-header border-bottom">
                    <h5 className="offcanvas-title mb-0"><i className="bi bi-question-circle me-2" />¿Cómo crear mi diseño?</h5>
                    <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
                </div>
                <div className="offcanvas-body" ref={bodyRef}>
                    {error ? (
                        <div className="alert alert-danger">No se pudo cargar la guía. Intente de nuevo.</div>
                    ) : html ? (
                        <div dangerouslySetInnerHTML={{ __html: html }} />
                    ) : (
                        <div className="text-center py-5"><span className="spinner-border spinner-border-sm me-2" />Cargando guía...</div>
                    )}
                </div>
            </div>
        </>
    );
};
